import React from 'react'
import sumBy from 'lodash/sumBy'
import { i18n } from '../../index'
import IndexDisplay from '../IndexDisplay'
import css from './thumbsUp.css'

function IndexSection({ data }) {
  const totalTarget = Math.round(sumBy(data, 'target'))
  const totalActual = Math.round(sumBy(data, 'actual'))
  const successRate = totalTarget > 0 ? ((totalActual / totalTarget) * 100).toFixed(2) : '-'
  console.log(totalActual, totalTarget, successRate)
  return (
    <div className={css.indexContainer}>
      <IndexDisplay label={i18n.t('reporting.label.thumbsUp.target')} value={totalTarget} />
      <IndexDisplay label={i18n.t('reporting.label.thumbsUp.actual')} value={totalActual} />
      <IndexDisplay label={i18n.t('reporting.label.thumbsUp.efficiency')} value={successRate} />
    </div>
  )
}

export default IndexSection
